import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import history from 'store/history';
import { random } from 'utils/colors';
import { ROUTE_THINK } from 'constants/urls';
import thinkTankImage from 'assets/images/thinkTankLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddUsersChat from 'components/AddUsers';
import Avatar from 'components/Avatar';
import {
  UpgradeWrapper, MainWrapper, Description, ButtonsWrapper, Button, Image, Title2, InputText,
  InputTitle, InputDescription, MembersWrapper, AddUsers, CalendTitle, OptionsTitle, CheckWrapper,
  Checkbox, CheckboxText, ButtonNext, BackArrow, ErrorMessage, SeeMore,
  MembersTitle, ButtonNextWrapper, MainTitle,
} from './styles';


class Upgrade extends Component {
  constructor(props) {
    super(props);

    this.state = {
      backgroundColor: random(),
      section: 'INTRODUCTION',
      text: '',
      description: '',
      chat: {},
      socialNetworkMovement: false,
      blog: false,
      project: false,
      openInnovation: false,
      loading: false,
      chatMembers: [props.user.id],
      error: '',
      hideSocialNetworkMovement: true,
      hideBlog: true,
      hideProject: true,
      hideOpenInnovation: true,
      showInviteUsers: false,
    };
  }

  componentDidMount() {
    const { thinkChats, match } = this.props;
    if (thinkChats) {
      const chatFound = thinkChats.find(chat => chat.id === parseInt(match.params.id, 10));
      if (chatFound) {
        this.setState({ chat: chatFound });
      }
    }

    this.setBreadcrumb1();
  }

  componentDidUpdate(prevProps) {
    const { thinkChats, match } = this.props;
    if (thinkChats && prevProps.thinkChats !== thinkChats) {
      const chatFound = thinkChats.find(chat => chat.id === parseInt(match.params.id, 10));
      if (chatFound) {
        const aux = [];
        chatFound.users.forEach((user) => {
          aux.push(user.id);
        });
        this.setState({ chat: chatFound, chatMembers: aux });
      }
    }
  }

  setBreadcrumb1() {
    const {
      literals, setBreadcrumb,
    } = this.props;

    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.think,
        onClick: () => {
          history.push(ROUTE_THINK);
        },
      },
      {
        color: '#ffffff',
        text: literals.launchThinkTank,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  }

  setBreadcrumb2() {
    const {
      literals, setBreadcrumb,
    } = this.props;

    const breadcrumb = [
      {
        color: '#ffffff',
        text: literals.think,
        onClick: () => {
          history.push(ROUTE_THINK);
        },
      },
      {
        color: '#ffffff',
        text: literals.launch,
        onClick: () => {
          this.setState({ section: 'INTRODUCTION' });
          this.setBreadcrumb1();
        },
      },
      {
        color: '#ffffff',
        text: literals.info,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  }

  setBreadcrumb3() {
    const {
      literals, setBreadcrumb,
    } = this.props;

    const breadcrumb = [
      {
        text: literals.think,
        onClick: () => {
          history.push(ROUTE_THINK);
        },
      },
      {
        text: literals.launch,
        onClick: () => {
          this.setState({ section: 'INTRODUCTION' });
          this.setBreadcrumb1();
        },
      },
      {
        text: literals.info,
        onClick: () => {
          this.goToForm();
        },
      },
      {
        text: literals.options,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  }

  handleBackToThink = () => {
    history.push(ROUTE_THINK);
  }

  handleSubmitForm = () => {
    const { literals } = this.props;
    const {
      text, description, chatMembers,
    } = this.state;
    if (text !== '' && description !== '' && chatMembers.length > 0) {
      this.setState({ section: 'OPTIONS' });
      this.setBreadcrumb3();
    } else {
      this.setState({ error: literals.errorFillAll });
    }
  }

  goToForm = () => {
    this.setState({ section: 'FORM' });
    this.setBreadcrumb2();
  }

  selectSection = () => {
    const { section } = this.state;
    switch (section) {
      case 'INTRODUCTION':
        return this.renderIntroduction();
      case 'FORM':
        return this.renderForm();
      case 'CALENDLY':
        return this.renderCalendly();
      case 'OPTIONS':
        return this.renderOptions();
      default:
        return <React.Fragment />;
    }
  }

  handleShowInviteForm = () => {
    this.setState({ showInviteUsers: true });
  }

  handleChangeName = (event) => {
    const { value } = event.target;
    this.setState({ text: value });
  }

  handleChangeDescription = (event) => {
    const { value } = event.target;
    this.setState({ description: value });
  }

  clickUser = (id) => {
    const { chatMembers } = this.state;

    if (!_.find(chatMembers, member => member === id)) {
      chatMembers.push(id);
    } else {
      _.remove(chatMembers, member => member === id);
    }
    this.setState({ chatMembers });
  }

  inviteUsers = (users) => {
    const { chat, chatMembers } = this.state;

    _.forEach(users, (user) => {
      if (!_.find(chat.users, { id: user.id })) {
        chat.users.push(user);
      }

      if (!_.find(chatMembers, member => member === user.id)) {
        chatMembers.push(user.id);
      }
    });

    this.setState({ chatMembers, chat, showInviteUsers: false });
  }

  killSeed = () => {
    const { killThinkSeed, user } = this.props;
    const { chat } = this.state;
    if (chat.element_related && chat.element_related.creator && chat.element_related.creator.id === user.id) {
      this.setState({ loading: true }, () => killThinkSeed(chat.element_related.id).then(() => this.afterKillSeed()));
    }
  }

  afterKillSeed = () => {
    this.setState({ loading: false });
    history.push('/think');
  }

  launchSeed = () => {
    const { launchThinkTank } = this.props;
    const {
      chat, text, description, socialNetworkMovement, blog, project, openInnovation, chatMembers,
    } = this.state;
    let members = '';
    chatMembers.forEach((user, index) => {
      if (index < chat.users.length - 1) {
        members += `${user},`;
      } else {
        members += user;
      }
    });
    const params = {
      id: chat.element_related.id,
      name: text,
      description,
      members,
      socialNetworkMovement: socialNetworkMovement ? 1 : 0,
      blog: blog ? 1 : 0,
      project: project ? 1 : 0,
      openInnovation: openInnovation ? 1 : 0,
    };
    this.setState({ loading: true }, () => launchThinkTank(params).then(() => this.setState({ loading: false, section: 'CALENDLY' })).catch(() => this.setState({ loading: false, section: 'OPTIONS', error: 'Error' })));
  }

  renderMembers() {
    const { chat, chatMembers } = this.state;
    const { user: actualUser } = this.props;
    if (chat) {
      const chatFound = chat;
      if (chatFound && chatFound.users) {
        const users = chatFound.users.filter(user => user.id !== actualUser.id);
        return users.map(({ id, firstname, avatar }) => {
          const selected = !!_.find(chatMembers, member => member === id);
          return (
            <Avatar size={72} firstname={firstname} id={id} avatar={avatar} onClick={this.clickUser} selected={selected} />
          );
        });
      }
    }
    return <React.Fragment />;
  }

  renderIntroduction() {
    const { literals, user } = this.props;
    const { loading, chat } = this.state;
    const creator = chat && chat.element_related && chat.element_related.creator.id === user.id;
    return (
      <UpgradeWrapper>
        <MainWrapper>
          <Description>
            {literals.titleThinkTank}
          </Description>
          <Description>
            {literals.descriptionThinkTank}
          </Description>
          <Image>
            <img src={thinkTankImage} alt='' />
          </Image>
          <ButtonsWrapper>
            <Button type='reject' disabled={!creator} onClick={this.killSeed}>
              {loading && <CircularProgress size={40} style={{ color: 'black' }} className='buttonProgress' />}
              {!loading && literals.killThinkSeed}
            </Button>
            <Button backgroundColor='green' type='accept' onClick={this.goToForm}>
              {literals.launchThinkTank}
            </Button>
          </ButtonsWrapper>
        </MainWrapper>
      </UpgradeWrapper>
    );
  }

  renderForm() {
    const { literals } = this.props;
    const {
      backgroundColor, text, description, error, showInviteUsers, chatMembers,
    } = this.state;
    if (showInviteUsers) {
      return (
        <AddUsersChat
          onInvite={this.inviteUsers}
          quitView={() => this.setState({ showInviteUsers: false })}
        />
      );
    }
    return (
      <UpgradeWrapper backgroundColor={backgroundColor.color}>
        <MainWrapper backgroundColor={backgroundColor.color}>
          <Title2>
            {literals.titleForm1}
            <br />
            {literals.titleForm2}
          </Title2>
          <InputTitle error={error !== '' && text === ''}>
            {literals.name}
          </InputTitle>
          <InputText error={error !== '' && text === ''}>
            <input type='text' value={text} onChange={this.handleChangeName} />
            {error !== '' && text === '' && (
              <i style={{ color: backgroundColor.contrastColor }} className='fas fa-exclamation-triangle' />
            )}
          </InputText>
          <InputTitle>
            {literals.description}
          </InputTitle>
          <InputDescription>
            <textarea name='Text1' cols='40' rows='5' value={description} onChange={this.handleChangeDescription} />
            {error !== '' && description === '' && (
              <i style={{ color: backgroundColor.contrastColor }} className='fas fa-exclamation-triangle' />
            )}
          </InputDescription>
          <MembersTitle>
            {literals.members}
          </MembersTitle>
          <MembersWrapper>
            {this.renderMembers()}
            <AddUsers onClick={this.handleShowInviteForm}>
              <i className='fas fa-plus fa-3x' />
            </AddUsers>
            {error !== '' && chatMembers.length < 1 && (
              <i style={{ color: backgroundColor.contrastColor }} className='fas fa-exclamation-triangle' />
            )}
          </MembersWrapper>
          {error !== '' && (
            <ErrorMessage>{error !== '' && error}</ErrorMessage>
          )}
          <ButtonNextWrapper>
            <Button
              type='next'
              onClick={this.handleSubmitForm}
              color={backgroundColor.color}
            >
              {literals.next}
            </Button>
          </ButtonNextWrapper>
        </MainWrapper>
      </UpgradeWrapper>
    );
  }

  renderCalendly() {
    const { literals } = this.props;
    const {
      backgroundColor,
    } = this.state;
    return (
      <UpgradeWrapper backgroundColor={backgroundColor.color}>
        <MainWrapper type='calendly' backgroundColor={backgroundColor.color}>
          <CalendTitle>
            {literals.calendlyTitle}
          </CalendTitle>
          <div className='text-align-center mt20 mb20'>
            <button className='primary' onClick={this.handleBackToThink}>{literals.backToThink}</button>
          </div>
          <iframe title='hello' src='https://calendly.com/crowdcentaurs_medioslocales/think-tanks-for-impact?text_color=173630&primary_color=48b19c' />
        </MainWrapper>
      </UpgradeWrapper>
    );
  }

  renderOptions() {
    const { literals } = this.props;
    const {
      backgroundColor, socialNetworkMovement, blog, project, openInnovation, loading, error,
      hideBlog, hideOpenInnovation, hideProject, hideSocialNetworkMovement,
    } = this.state;
    return (
      <UpgradeWrapper backgroundColor={backgroundColor.color}>
        <MainWrapper backgroundColor={backgroundColor.color}>
          <OptionsTitle>
            {literals.optionsTitle}
          </OptionsTitle>
          <CheckWrapper>
            <Checkbox>
              <input type='checkbox' value={socialNetworkMovement} checked={socialNetworkMovement} onChange={() => this.setState({ socialNetworkMovement: !socialNetworkMovement })} />
              <CheckboxText type='title'>
                {literals.socialNetworkMovement}
                <br />
                <br />
              </CheckboxText>
              <SeeMore onClick={() => this.setState({ hideSocialNetworkMovement: !hideSocialNetworkMovement })}>{hideSocialNetworkMovement ? literals.seeMore : literals.seeLess}</SeeMore>
              {!hideSocialNetworkMovement && (
                <CheckboxText hide={hideSocialNetworkMovement}>
                  {literals.socialNetworkMovement2}
                  <br />
                  <br />
                  {literals.socialNetworkMovement3}
                  <br />
                  <a href='https://www.playgroundmag.net/movements/drought-proof-society' target='_blank' rel='noopener noreferrer'>See example here</a>
                </CheckboxText>
              )}
            </Checkbox>
            <Checkbox>
              <input type='checkbox' value={blog} checked={blog} onChange={() => this.setState({ blog: !blog })} />
              <CheckboxText type='title'>
                {literals.blog}
                <br />
                <br />
              </CheckboxText>
              <SeeMore onClick={() => this.setState({ hideBlog: !hideBlog })}>{hideBlog ? literals.seeMore : literals.seeLess}</SeeMore>
              {!hideBlog && (
                <CheckboxText>
                  {literals.blog2}
                  <br />
                  <br />
                  {literals.blog3}
                  <br />
                  <a href='https://www.capitalradio.es/' target='_blank' rel='noopener noreferrer'>See example here</a>
                </CheckboxText>
              )}
            </Checkbox>
            <Checkbox>
              <input type='checkbox' value={project} checked={project} onChange={() => this.setState({ project: !project })} />
              <CheckboxText type='title'>
                {literals.project}
                <br />
                <br />
              </CheckboxText>
              <SeeMore onClick={() => this.setState({ hideProject: !hideProject })}>{hideProject ? literals.seeMore : literals.seeLess}</SeeMore>
              {!hideProject && (
                <CheckboxText>
                  {literals.project2}
                  <a href='https://myopia.app/' target='_blank' rel='noopener noreferrer'>https://myopia.app/</a>
                  {literals.project3}
                </CheckboxText>
              )}
            </Checkbox>
            <Checkbox>
              <input type='checkbox' value={openInnovation} checked={openInnovation} onChange={() => this.setState({ openInnovation: !openInnovation })} />
              <CheckboxText type='title'>
                {literals.openInnovation}
                <br />
                <br />
              </CheckboxText>
              <SeeMore onClick={() => this.setState({ hideOpenInnovation: !hideOpenInnovation })}>{hideOpenInnovation ? literals.seeMore : literals.seeLess}</SeeMore>
              {!hideOpenInnovation && (
                <CheckboxText>
                  {literals.openInnovation2}
                  <br />
                  <a href='https://socialab.com/' target='_blank' rel='noopener noreferrer'>See example here</a>
                </CheckboxText>
              )}
            </Checkbox>
          </CheckWrapper>
          {!loading && error !== '' && (
            <ErrorMessage>{error}</ErrorMessage>
          )}
          <ButtonNextWrapper>
            <Button type='next' color={backgroundColor.color} onClick={this.launchSeed}>
              {loading && <CircularProgress size={40} style={{ color: 'black' }} className='buttonProgress' />}
              {!loading && literals.next}
            </Button>
          </ButtonNextWrapper>
        </MainWrapper>
      </UpgradeWrapper>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.selectSection()}
      </React.Fragment>
    );
  }
}
Upgrade.propTypes = {
  literals: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  thinkChats: PropTypes.array,
  setBreadcrumb: PropTypes.func.isRequired,
  launchThinkTank: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

Upgrade.defaultProps = {
  thinkChats: [],
};

export default Upgrade;



// WEBPACK FOOTER //
// ./src/routes/Upgrade/components/Upgrade.jsx